import { resetPasswordActionTypes } from '../actions/reset-password-action-types';




const initialState = {
    status: "",
    passwordResetComplete: false,
    passwordResetError: false,
    passwordResetErrorMessage: ''
   
};

export const resetPassword = (state = initialState, action) => {


    switch (action.type) {

        case resetPasswordActionTypes.RESET_PASSWORD_REQUEST:
            return { resetPassword: true };
        case resetPasswordActionTypes.RESET_PASSWORD_RECEIVED:
            return {
                ...state, 
                status:"Success!",
            passwordResetComplete: true,
            passwordResetError: action.resetPassword.errorMessage!=null,
            passwordResetErrorMessage: action.resetPassword.errorMessage ? action.resetPassword.errorMessage : null
        };
        case resetPasswordActionTypes.RESET_PASSWORD_FAILED:
        return {...state,
             status: "Error",
             passwordResetErrorMessage: action.error.errorMessage,
             passwordResetError: true,
            };
        default:
            return state;

    }

};



// WEBPACK FOOTER //
// ./src/signup/reducers/reset-password-reducer.js